import { Component, Input, OnInit } from '@angular/core';
import { INSURER_CODE } from 'src/app/share/constants/common.info';

@Component({
  selector: 'app-order-summary-note',
  templateUrl: './order-summary-note.component.html',
  styleUrls: ['./order-summary-note.component.scss']
})
export class OrderSummaryNoteComponent {
  @Input() text: string;
  @Input() insurerCode: string;

  constructor() { }

  getInsurerSummaryNote() {
    if (this.insurerCode == INSURER_CODE.Chubb) {
      return {
        note: "comparison.chubbOrderSummaryNote",
        show: true
      };
    }

    return {
      note: "",
      show: false
    };
  }
}
